{
  "title": "Card catalog",
  "intro": "The card database: every card the shop can sell — games, sets and cards. It is not your stock: products for sale are made from these cards.",
  "breadcrumb": "Where you are in the card catalog",
  "games": {
    "title": "Games",
    "add": "Add a game",
    "save": "Save the game",
    "created": "Game \"{{name}}\" added",
    "empty": "No games yet",
    "empty_hint": "Add the first game (for example Pokémon).",
    "hidden": "Hidden",
    "save_order": "Save this order",
    "undo_order": "Put the order back",
    "order_saved": "Order saved",
    "price_check": "Price check",
    "price_check_title": "Price check for {{name}}",
    "price_check_intro": "How many days without a price check before a card of this game turns yellow (check soon) or red (overdue). Leave empty to use the shop setting.",
    "warn_days": "Yellow after … days",
    "alert_days": "Red after … days",
    "shop_default": "Shop setting: {{days}}",
    "days_suffix": "days",
    "price_check_rule": "Yellow after {{warn}} days · red after {{alert}} days",
    "price_check_custom": "Own price check: yellow after {{warn}} · red after {{alert}} days",
    "price_check_saved": "Price check days saved",
    "days_range": "Enter a whole number from 1 to 365.",
    "days_order": "Yellow must come before red: the yellow number must be smaller than the red one ({{warn}} / {{alert}})."
  },
  "sets": {
    "title": "Sets",
    "intro": "Sets of this game. Open a set to see and add its cards.",
    "add": "Add a set",
    "edit": "Change the set",
    "edit_named": "Change {{name}}",
    "save": "Save the set",
    "created": "Set \"{{name}}\" added",
    "saved": "Set saved",
    "empty": "No sets yet",
    "empty_hint": "Add a set with its code, for example SV2a.",
    "duplicate": "This game already has a set with that code and card language.",
    "delete": "Delete the set",
    "delete_named": "Delete {{name}}",
    "delete_title": "Delete this set?",
    "delete_consequence": "\"{{name}}\" is removed from the card catalog. Products for sale are not touched.",
    "deleted": "Set deleted",
    "in_use": "This set still has cards or products — it cannot be deleted."
  },
  "cards": {
    "title": "Cards",
    "intro": "Cards of this set. Japanese and English names are shown side by side.",
    "add": "Add a card",
    "edit": "Change the card",
    "edit_named": "Change {{name}}",
    "save": "Save the card",
    "created": "Card \"{{name}}\" added",
    "saved": "Card saved",
    "empty": "No cards in this set yet",
    "empty_hint": "Add the first card with its number and name.",
    "in_stock": "The shop has",
    "stock_n": "{{count}} in stock",
    "stock_none": "none",
    "delete": "Delete the card",
    "delete_named": "Delete {{name}}",
    "delete_title": "Delete this card?",
    "delete_consequence": "\"{{name}}\" is removed from the card catalog.",
    "deleted": "Card deleted",
    "in_use": "Products are made from this card — it cannot be deleted.",
    "import": "Import the cards of this set ({{source}})",
    "imported": "{{count}} cards imported",
    "import_off": "Importing from this source is not switched on yet."
  },
  "fields": {
    "game": "Game",
    "set": "Set",
    "set_code": "Set code",
    "set_code_hint": "As printed on the card, for example SV2a",
    "set_name": "Set name",
    "language": "Card language",
    "language_hint": "The language printed on the cards",
    "name_en": "Name (English)",
    "name_jp": "Name (Japanese)",
    "name_ja": "Name (Japanese)",
    "name_th": "Name (Thai)",
    "number": "Card number",
    "number_hint": "As printed, for example 085/165",
    "rarity": "Rarity",
    "card_type": "Card type",
    "character": "Character",
    "card_name": "Name",
    "reference_image": "Picture (web address)",
    "reference_image_hint": "A picture of the card on the internet (https://…) — shown when choosing the card",
    "reference_image_bad": "Use a web address that starts with https://",
    "release_date": "Release date",
    "total_cards": "Cards in the set",
    "total_cards_bad": "Use a whole number",
    "logo": "Set logo",
    "publisher": "Publisher"
  },
  "languages": {
    "JP": "Japanese",
    "EN": "English",
    "TH": "Thai",
    "KR": "Korean",
    "ZH": "Chinese"
  },
  "picker": {
    "label": "Which card?",
    "hint": "Type the Japanese or English name, the number, or the set code and number (e.g. SV2a 085). You can also scan a graded card's number.",
    "placeholder": "e.g. ブラッキー / Umbreon / 085",
    "set_filter": "Only this set",
    "all_sets": "All sets",
    "results": "Matching cards",
    "searching": "Searching…",
    "clear": "Clear",
    "none": "No card matches \"{{text}}\".",
    "error": "The card list could not be searched. Try again.",
    "number": "No. {{number}}",
    "set_loading": "…",
    "change": "Choose another card",
    "create": "Not in the list? Add a new card",
    "use_as_cert": "{{cert}} is a graded card's number — use it"
  },
  "create": {
    "title": "Add a new card to the card catalog",
    "hint": "Four boxes are enough. You can add more details later in the card catalog.",
    "save": "Add this card",
    "cancel": "Cancel",
    "required": "Please fill this in",
    "duplicate": "This set already has this card.",
    "twin": "This set already has a card with number {{number}}:",
    "use_existing": "Use this card"
  }
}
